import React, { useState } from 'react';
import styled from 'styled-components';
import ArrowBottom from 'assets/PolygonActive.svg';

interface Option {
    label: string;
    value: string;
}

interface DropdownProps {
    options: Option[];
    placeholder?: string;
    onChange?: (value: string) => void;
    initialValue?: string;
}

export const Dropdown: React.FC<DropdownProps> = ({
    options,
    placeholder = 'Select option',
    onChange,
    initialValue,
}) => {
    const [isOpen, setIsOpen] = useState(false);
    const [selected, setSelected] = useState<Option | null>(
        options.find(o => o.value === initialValue) || null
    );

    const handleSelect = (option: Option) => {
        setSelected(option);
        setIsOpen(false);
        onChange?.(option.value);
    };

    return (
        <Wrapper>
            <Control onClick={() => setIsOpen(prev => !prev)}>
                <Text>{selected?.label || placeholder}</Text>
                <Arrow $open={isOpen} />
            </Control>

            {isOpen && (
                <Menu>
                    {options.map(option => (
                        <MenuItem
                            key={option.value}
                            onClick={() => handleSelect(option)}
                        >
                            {option.label}
                        </MenuItem>
                    ))}
                </Menu>
            )}
        </Wrapper>
    );
};

const Wrapper = styled.div`
    position: relative;
    width: 10rem;
    height: 30px;

    @media (max-width: 768px) {
        width: 100%;
    }
`;

const Control = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    border: 1px solid #A4A4A4;
    color: #000000;
    font-weight: 600;
    padding: 10px 12px;
    border-radius: 8px;
    cursor: pointer;
    height: 30px;
    background: white;
    gap: 6px;

    @media (max-width: 768px) {
        padding: 8px 10px;
        height: 28px;
    }
`;

const Menu = styled.div`
    position: absolute;
    top: calc(100% + 6px);
    left: 0;
    right: 0;
    background: #fff;
    border: 1px solid #ddd;
    border-radius: 8px;
    overflow: hidden;
    z-index: 10;
    padding: 7px 6px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);

    @media (max-width: 768px) {
        padding: 5px 4px;
    }
`;

const MenuItem = styled.div`
    padding: 10px 12px;
    cursor: pointer;
    border-radius: 6px;
    color: #000000;
    font-weight: 400;
    font-size: 15px;

    &:hover {
        background: rgba(226, 229, 255, 1);
    }

    @media (max-width: 768px) {
        padding: 8px 10px;
        font-size: 14px;
    }
`;

const Text = styled.span`
    font-size: 15px;
    font-weight: 400;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

    @media (max-width: 768px) {
        font-size: 14px;
    }
`;

const Arrow = styled(ArrowBottom)<{ $open: boolean }>`
    transition: transform 0.2s ease;
    transform: rotate(${props => (props.$open ? '0deg' : '180deg')});
    flex-shrink: 0;

    path {
        fill: #00000050;
    }

    @media (max-width: 768px) {
        width: 12px;
        height: 12px;
    }
`;
